export default __webpack_public_path__ + "static/media/gcp-pro.e10c6fe2.png";